import ReactDOM from 'react-dom';
//import 'semantic-ui-css/semantic.min.css';
import 'bootstrap/scss/bootstrap-grid.scss';
import 'react-toastify/dist/ReactToastify.css';
import 'aos/dist/aos.css';
import './overwrite.scss';
import './styles.scss';
import { AppContainer, } from 'react-hot-loader';
import App from './App';
import reportWebVitals from './reportWebVitals';



const render = (Component: any) => {
  ReactDOM.render(
    <AppContainer>
      <Component />
    </AppContainer>,
    document.getElementById('root')
  );
};

render(App);

if (module.hot) {
  module.hot.accept('./App', () => {
    render(require('./App'));
  });
}


reportWebVitals();

if ('ethereum' in window) {
  //(window.ethereum as any).autoRefreshOnNetworkChange = false;
  (window.ethereum as any).on('chainChanged', () => window.location.reload());
  (window.ethereum as any).on('accountsChanged', () => window.location.reload());
}
